import { HubStatsProgressBar } from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsProgressBar";
import { IRewardPoints } from "apps/BWW_PLAY_HUB/components/HubStats/utils";
import { map } from "lodash";
import { TGraphItems } from "modules/types/advanced_stats";
import moment from "moment";
import React from "react";
import styled from "styled-components";


const DaysGraphWrapper = styled.div`
	display: flex;
	height: 200px;
	justify-content: space-evenly;
`;

const DaysGraphItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const DaysTitle = styled.div`
	font-size: 12px;
	line-height: 14px;
	font-weight: 500;
	text-align: center;
	margin-top: 15px;
`;

interface IHubStatsDaysGraph {
	items: TGraphItems;
	format?: string | null;
	className?: string;
}

const getDayOfWeek = (date: string, format: string | null = 'ddd') => {
	if (format === null) {
		return date;
	}

	return moment(date).format(format);
};

export const HubStatsDaysGraph: React.FC<IHubStatsDaysGraph> = ({ items, format, className }) => {
	return (
		<DaysGraphWrapper className={className}>
			{ map(items, (item: IRewardPoints[], index) => {
				return (
					<DaysGraphItem key={index}>
						<HubStatsProgressBar items={item} vertical={true} />
						<DaysTitle>{ getDayOfWeek(index, format) }</DaysTitle>
					</DaysGraphItem>
				)
			})}
		</DaysGraphWrapper>
	);
};
